import script from "./Matrix.vue?vue&type=script&setup=true&lang=js"
export * from "./Matrix.vue?vue&type=script&setup=true&lang=js"

import "./Matrix.vue?vue&type=style&index=0&id=170b5e78&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-170b5e78"]])

export default __exports__